<template>
  <Card containerClass="mb-5 shadow-sm" titleContainerClass="d-flex justify-content-center">
    <template #cardHeader>
      <div class="card-header">
        <h3 class="card-title align-items-start flex-column">
          {{$t('absences.setting.working_days')}}
        </h3>
        <div class="card-toolbar">
          <Button @click.prevent="saveWorkDay" btn-class="btn-primary" type="button" id="submit_btn" btn-text="button.save" :is-loading="isLoading"></Button>
        </div>
      </div>
    </template>
    <template #cardBody>
      <div class="row">
        <div v-for="weekDay in getWeekDays" class="col-md-6">
          <Card containerClass="mb-5 shadow-sm" titleContainerClass="d-flex justify-content-center">
            <template #cardBody>
              <div class="d-flex justify-content-between align-items-center">
                <span class="fs-3 fw-bold">{{ weekDay[locale] }}</span>
                <div class="form-check form-switch form-check-custom form-check-solid">
                  <input @change.prevent="changeValue(weekDay.value, $event)" :name="weekDay.value" class="form-check-input" type="checkbox" :checked="hasWorkDay(weekDay.value)" id="flexSwitchDefault"/>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import { onMounted, computed, watch, ref } from 'vue'
import Card from "@/Modules/Financial/components/Card.vue";
import Button from "@/components/Button.vue";
import { useStore } from 'vuex'
import {useLocales} from "@/composables/locales";

const store = useStore()
const isLoading = ref(false)
const { locale } = useLocales()

const workdaysForm = ref([])

const getWeekDays = computed(() => store.getters['holydays/getWeekdayEnums'])
const currentCompany = computed(() => store.getters['offices/getSelectedCompany'])

const currentCompanyWorkDays = computed(() => store.getters['holydays/getCompanyWorkDays'](currentCompany.value?.id))

watch(() => currentCompanyWorkDays.value, (newValue) => {
  workdaysForm.value = newValue
}, {deep: true})

watch(() => currentCompany.value, (value) => {
  if(value && !currentCompanyWorkDays.value.length) {
    store.dispatch('holydays/getCountryWorkdays', currentCompany.value.id)
  }
})

onMounted(async () => {

  store.dispatch('holydays/loadWeekdayEnums')

  if(currentCompany.value) {
    store.dispatch('holydays/getCountryWorkdays', currentCompany.value.id)
  }
})

function changeValue(value, $event) {
  if($event.target.checked) {
    if (workdaysForm.value.includes(value)) {
      return;
    }
    workdaysForm.value.push(value)
  } else {
    workdaysForm.value = workdaysForm.value.filter(x => x !== value)
  }
}

function hasWorkDay(day){
  return !!workdaysForm.value.includes(day)
}

async function saveWorkDay() {
  isLoading.value = true

  await store.dispatch('holydays/setCountryWorkdays', {
    company_id : currentCompany.value.id,
    data : workdaysForm.value,
  }).then(() => {
    window.toastr['success'](i18n.global.t('bank.updated'));
  }).finally(() => {
    isLoading.value = false
  })
}

</script>